import { Modal } from 'antd'

import CancelIcon from 'src/assets/cancel.svg'
import withSentryWrapper from 'src/components/common/withSentryWrapper'

const ModalContainer = ({
    visible = false,
    width = '40%',
    footer = null,
    children = '',
    closable = true,
    className = 'incident-modal-root',
    bodyStyle = null,
    destroyOnClose,
    style,
    closeModal,
    maskClosable = false,
    zIndex,
    afterClose,
}) => {
    return (
        <>
            <Modal
                destroyOnClose={destroyOnClose}
                className={className}
                style={style}
                bodyStyle={bodyStyle ?? { background: '#20293C' }}
                open={visible}
                width={width}
                onCancel={closeModal}
                closable={closable}
                maskClosable={maskClosable}
                zIndex={zIndex ?? 1000}
                closeIcon={
                    <img
                        className="custom-modal-close mx-auto mt-2 focus:outline-none"
                        src={CancelIcon}
                        width="25"
                        height="25"
                        alt="close"
                    />
                }
                footer={footer}
                afterClose={afterClose}
            >
                {children}
            </Modal>
        </>
    )
}

export default withSentryWrapper(ModalContainer)
